import { createAction, props } from '@ngrx/store'

export const actions_client_user = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  SetMe: createAction('[CMS][ClientUuser] SetMe', props<{ me: any }>()),
}
